import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../Interfaces/Interfaces";
import { getUsers, putComment } from "../../actions/index";
import SearchBar from "./SearchBar";

const Usuarios: React.FC = (): JSX.Element => {
  const [editingComment, setEditingComment] = useState<number | null>(null)
  const [commentToEdit, setCommentToEdit] = useState<string>("");
  const users = useSelector((state: RootState) => state.users);

  const token = localStorage.getItem("token");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsers(token));
  }, []);

  return (
    <div className="p-8 flex flex-col">
      <SearchBar />

      <div className="w-full h-full flex flex-col  pt-10 font-roboto">
        <div className="flex flex-row  font-bold text-white  w-full">
          <div className="border w-80 p-2 bg-background_home">
            <p>Nombre</p>
          </div>

          <div className="border w-80 p-2 bg-background_home">
            <p>Apellido</p>
          </div>

          <div className="border w-96 p-2 bg-background_home">
            <p>Mail</p>
          </div>

          <div className="border w-32 p-2 bg-background_home">
            <p>DNI</p>
          </div>

          <div className="border w-32 p-2 bg-background_home">
            <p>Vinculacion</p>
          </div>

          <div className="border w-60 p-2 bg-background_home">
            <p>Comentario</p>
          </div>
        </div>
        {users.map((user: any) => (
          <div key={user.id} className="flex flex-row">
            <Link className="flex flex-row" to={"/adminpanel/" + user.id}>
              <div className="border w-80 p-2">
                <p>{user.name}</p>
              </div>

              <div className="border w-80 p-2">
                <p>{user.lastName}</p>
              </div>

              <div className="border w-96 p-2">
                <p>{user.email}</p>
              </div>

              <div className="border w-32 p-2">
                <p>{user.dni}</p>
              </div>

              <div className="border w-32 p-2">
                <p>{user.vinculacion}</p>
              </div>
            </Link>
            <div className="border w-44 p-2">
            {editingComment === user.comentario.id ? (
                <input
                  className="w-40"
                  value={commentToEdit} // Mostrar el valor del nuevo estado
                  onChange={(e) => setCommentToEdit(e.target.value)} // Actualizar el nuevo estado
                />
              ) : (
                <p className="w-40" >{user.comentario.comentario}</p>
              )}
            </div>

            {editingComment === user.comentario.id ? (
              <button className="border px-1.5"
                onClick={() => {
                  dispatch(putComment(token, user.comentario.id, { input: commentToEdit }));
                  dispatch(getUsers(token))
                  setEditingComment(null);
                }}
              >
                Guardar
              </button>
            ) : (
              <button className="border px-3" onClick={() => {
                setCommentToEdit(user.comentario.comentario);
                setEditingComment(user.comentario.id);
              }}>
                Editar
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Usuarios;
